import React from "react";
import { FeedLikeType } from "../../types";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import ReactPlayer from "react-player";
import { BiLike } from "react-icons/bi";

type LikeProps = {
  like?: FeedLikeType | null;
};
const Like: React.FC<LikeProps> = ({ like }) => {
  if (!like) {
    return null;
  }
  const allMediaUrls: string[] = [];
  if (like.feedLikes) {
    like.feedLikes.forEach((userLikes) => {
      if (
        userLikes.communityFeed &&
        userLikes.communityFeed?.mediaUrl! !== null
      ) {
        const feedMe =
          userLikes.communityFeed && userLikes.communityFeed?.mediaUrl!;
        userLikes.communityFeed?.mediaUrl &&
          feedMe?.forEach((url) => {
            if (url.imageUrl) {
              allMediaUrls.push(...url.imageUrl);
            }
            if (url.videoUrl) {
              allMediaUrls.push(...url.videoUrl);
            }
          });
      }
    });
  }

  if (like.feedLikes) {
    like.feedLikes.forEach((userLikes) => {
      if (userLikes.userFeed && userLikes.userFeed?.media! !== null) {
        const feedMe = userLikes.userFeed && userLikes.userFeed?.media!;
        userLikes.userFeed?.media &&
          feedMe?.forEach((url) => {
            if (url.imageUrl) {
              allMediaUrls.push(...url.imageUrl);
            }
            if (url.videoUrl) {
              allMediaUrls.push(...url.videoUrl);
            }
          });
      }
    });
  }

  const allVideoUrls: string[] = [];
  const videos = like.feedLikes?.flatMap((media) =>
    media.communityFeed?.mediaUrl!.flatMap((vide) => vide.videoUrl)
  );

  const videos2 = like.feedLikes?.flatMap((media) =>
    media.userFeed?.media!.flatMap((vide) => vide.videoUrl)
  );
  const videoURLs = allMediaUrls.filter((url) => videos.includes(url));
  const videoURLss = allMediaUrls.filter((url) => videos2.includes(url));

  if (videoURLs) {
    allVideoUrls.push(...videoURLs);
  }

  if (videoURLss) {
    allVideoUrls.push(...videoURLss);
  }

  if (allMediaUrls.length === 0) {
    return (
      <div className="flex flex-col mt-11 mb-1 pb-20 px-5 lg:px-0">
        <div className="flex text-lightBlack text-center text-3xl justify-center w-full items-center font-Inter">
          <BiLike />
          No like
        </div>
      </div>
    ); // Handle case where no media URLs are found
  }

  let videoHash: string, thumbnailHash: string;
  return (
    <div className="flex flex-col mt-11 mb-1 px-5 lg:px-0">
      <div className="flex justify-between w-full items-center font-Inter text-sm">
        <div className="text-lightGreyText">
          Only you can see what you’ve liked
        </div>
        <div className=" text-midGreen font-semibold">+ Collection</div>
      </div>

      <div className="flex w-full bg-white p-1 overflow-hidden">
        <div className="grid lg:grid-cols-3 pb-5 lg:pb-2 h-full bg-white px-[2%] lg:px-0 pt-[23px] lg:pt-0 grid-cols-2 lg:bg-inherit gap-2 w-full overflow-hidden">
          {allMediaUrls &&
            allMediaUrls.map((media, index) => {
              const ipfsHashes = media.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                media !== null && (
                  <div
                    className="h-[199px] lg:h-[258px] shadow overflow-hidden"
                    key={index * 2}
                  >
                    {allVideoUrls.includes(media) ? (
                      <ReactPlayer
                        key={index}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ) : (
                      <img
                        id={`imga-${index}`}
                        src={ipfsGatewayImage(media)}
                        alt={`Media ${index}`}
                        className="w-full h-full object-cover object-center"
                      />
                    )}
                  </div>
                )
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Like;
